<div class="blackout-schedule-preview" [class.is-collapsed]="!isExpanded" data-testid="blackout-schedule-preview">

  <div class="preview-header">
    <button
      type="button"
      class="preview-toggle"
      (click)="toggleExpanded()"
      [attr.aria-expanded]="isExpanded"
      data-testid="blackout-preview-toggle"
     data-ui-name="Schedule preview Show week and day timeline" data-ui-component="blackout-hours-schedule-preview">
      <span class="preview-chevron" aria-hidden="true">{{ isExpanded ? '▾' : '▸' }}</span>
      <h4 data-ui-name="Schedule preview" data-ui-component="blackout-hours-schedule-preview" data-testid="blackout-hours-schedule-preview-schedule-preview">Schedule preview</h4>
      <span class="preview-toggle-hint" *ngIf="!isExpanded">Show week and day timeline</span>
    </button>
    <div class="preview-tabs" *ngIf="isExpanded">
      <button type="button" class="preview-tab" [class.is-active]="tab === 'week'" (click)="setTab('week')" data-ui-name="Week" data-ui-component="blackout-hours-schedule-preview" data-testid="blackout-hours-schedule-preview-week">Week</button>
      <button type="button" class="preview-tab" [class.is-active]="tab === 'day'" (click)="setTab('day')" data-ui-name="Day" data-ui-component="blackout-hours-schedule-preview" data-testid="blackout-hours-schedule-preview-day">Day</button>
    </div>
  </div>

  <div class="preview-body" *ngIf="isExpanded">

    <div class="preview-meta">
      <span *ngIf="normalizedGroups.length === 1">
        <strong>{{ normalizedGroups[0].name || 'Group' }}</strong> · {{ normalizedGroups[0].timezone }}
      </span>
      <span *ngIf="normalizedGroups.length > 1">
        <strong>{{ normalizedGroups.length }} groups</strong> overlaid
      </span>
      <span *ngIf="!normalizedGroups.length">No groups to preview</span>
    </div>

    <div class="preview-verdict">
      <span class="verdict-pill" [class.is-allowed]="verdict.allowed" [class.is-blocked]="!verdict.allowed">
        {{ verdict.allowed ? 'Available' : 'Non-working' }}
      </span>
      <span class="verdict-detail" *ngIf="previewClock.label">
        {{ previewClock.label }} · preview instant
      </span>
    </div>

    <div class="preview-controls">
      <label class="preview-control">
        <span class="preview-control-label">Preview task</span>
        <div class="select is-small">
          <select [ngModel]="taskType" (ngModelChange)="onTaskTypeChange($event)" data-testid="blackout-preview-task" data-ui-name="Preview task" data-ui-component="blackout-hours-schedule-preview">
            <option *ngFor="let task of markingTaskOptions" [ngValue]="task.id" data-ui-name="Task caption — task Type" data-ui-component="blackout-hours-schedule-preview" data-testid="blackout-hours-schedule-preview-task-caption-task-type" [attr.data-entity-key]="task.id" data-entity-type="task">{{ task.caption }}</option>
          </select>
        </div>
      </label>
    </div>

    <div class="preview-legend" *ngIf="normalizedGroups.length > 1">
      <span class="legend-item" *ngFor="let group of normalizedGroups">
        <span class="legend-swatch" [style.background]="group.color"></span>
        {{ group.name || group.key }}
      </span>
    </div>

    <div class="week-view" *ngIf="tab === 'week'">
      <div class="week-grid">
        <button
          type="button"
          class="week-day"
          *ngFor="let day of weekDays; trackBy: trackByDate"
          [class.is-selected]="day.date === selectedDate"
          (click)="selectWeekDay(day.date)"
          [attr.data-testid]="'blackout-preview-day-' + day.date"
         data-ui-name="Select Week Day" data-ui-component="blackout-hours-schedule-preview">
          <div class="week-day-head">
            {{ day.label }}
            <small>{{ day.sub }}<ng-container *ngIf="showBlockedStats"> · {{ isScheduleOn ? day.blockedPct + '% blk' : 'off' }}</ng-container></small>
          </div>
          <div class="week-day-lanes">
            <div
              class="week-seg"
              *ngFor="let seg of day.segments; trackBy: trackBySegment"
              [ngClass]="segmentClass(seg)"
              [style.top.%]="segmentTopPct(seg)"
              [style.height.%]="segmentHeightPct(seg)"
              [title]="segmentTitle(seg)"
            ></div>
          </div>
        </button>
      </div>
      <p class="preview-hint">Click a day to inspect its timeline. Green = available, red = non-working for the preview task.</p>
    </div>

    <div class="day-view" *ngIf="tab === 'day'">
      <p class="preview-day-label"><strong>{{ selectedDate }}</strong></p>
      <div class="day-timeline">
        <div class="hour-line" *ngFor="let h of hourGuides" [style.top.px]="(h / 24) * 420">
          <span>{{ formatHm(h * 60) }}</span>
        </div>
        <div
          class="day-seg-block"
          *ngFor="let layer of dayLayers"
          [style.top.px]="layer.top"
          [style.height.px]="layer.height"
          [style.background]="layer.color"
          [title]="layer.label"
        >{{ layer.label }}</div>
        <div class="preview-marker" *ngIf="previewMarkerTop >= 0" [style.top.px]="previewMarkerTop"></div>
      </div>
    </div>

    <div class="preview-stats" *ngIf="showBlockedStats" data-testid="blackout-preview-stats">
      <span>Week blocked: <strong data-testid="blackout-preview-week-blocked">{{ weekBlockedLabel }}</strong></span>
      <span>Selected day: <strong>{{ todayBlockedLabel }}</strong> blocked</span>
    </div>
  </div>
</div>
